import axios from 'axios';
import * as types from '../constants/ActionTypes';

const PPC_ENABLE_URL = 'ppcredit-checker';

// PayPal Credit enable checker logic
function PPCEnableChecker(response) {
  if (response && response.credit_accounts) {
    return Array.isArray(response.credit_accounts);
  }
  return false;
}

// Fetch PPCredit Account info for login user
function requestPPCEnable() {
  return {
    type: types.REQUEST_PPC_ENABLE,
  };
}

function receivePPCEnable(responseData) {
  return {
    type: types.RECEIVE_PPC_ENABLE,
    payload: PPCEnableChecker(responseData),
  };
}

function receivePPCEnableError() {
  return {
    type: types.RECEIVE_PPC_ENABLE_ERROR,
  };
}

export default function fetchPPCEnable() {
  return (dispatch) => {
    dispatch(requestPPCEnable());
    return axios.get(PPC_ENABLE_URL)
      .then((response) => {
        dispatch(receivePPCEnable(response.data));
      })
      .catch(() => {
        dispatch(receivePPCEnableError());
      });
  };
}
